import * as React from "react";
const SvgStartover = ({
  title,
  titleId,
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<rect width={24} height={24} x={2} y={2} rx={1} /><path d="M18.902 8.245a.6.6 0 0 1 .098.329v10.852a.6.6 0 0 1-.928.503l-7.822-5.112v4.524a.6.6 0 0 1-.6.6H9.6a.6.6 0 0 1-.6-.6V8.66a.6.6 0 0 1 .6-.6h.05a.6.6 0 0 1 .6.6v4.523l7.822-5.11a.6.6 0 0 1 .83.173z" /></svg>;
export default SvgStartover;